<div>

  <mat-form-field appearance="fill">
    <mat-label>Rechercher</mat-label>
    <input matInput #inputSearch (input)="applyFilter(inputSearch.value)">
    <button mat-icon-button matSuffix>
      <mat-icon>search</mat-icon>
    </button>
  </mat-form-field>


  <mat-table class="table-container" [dataSource]="clients" matSort matTableFilter>
    <ng-container matColumnDef="lastName">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Nom </mat-header-cell>
      <mat-cell *matCellDef="let client"> {{client.lastName}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="firstName">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Prénom </mat-header-cell>
      <mat-cell *matCellDef="let client"> {{client.firstName}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="address">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Adresse </mat-header-cell>
      <mat-cell *matCellDef="let client"> {{client.address}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="postalCode">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Code postal </mat-header-cell>
      <mat-cell *matCellDef="let client"> {{client.postalCode}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="city">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Ville </mat-header-cell>
      <mat-cell *matCellDef="let client"> {{client.city}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="country">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Pays </mat-header-cell>
      <mat-cell *matCellDef="let client"> {{client.country}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="landlinePhoneNumber">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Tél. fixe </mat-header-cell>
      <mat-cell *matCellDef="let client"> {{client.landlinePhoneNumber}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="mobilePhoneNumber">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Téléphone </mat-header-cell>
      <mat-cell *matCellDef="let client"> {{client.mobilePhoneNumber}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="email">
      <mat-header-cell *matHeaderCellDef mat-sort-header> Email </mat-header-cell>
      <mat-cell *matCellDef="let client"> {{client.email}} </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="['lastName', 'firstName', 'address', 'postalCode', 'city', 'country', 'landlinePhoneNumber', 'mobilePhoneNumber', 'email']"></mat-header-row>
    <mat-row *matRowDef="let client; columns: ['lastName', 'firstName', 'address', 'postalCode', 'city', 'country', 'landlinePhoneNumber', 'mobilePhoneNumber', 'email']"></mat-row>
  </mat-table>

  <mat-paginator [pageSize]="paginatorSize" [pageSizeOptions]="pageSizeOptions"></mat-paginator>

</div>
